export default __webpack_public_path__ + "static/media/homepod.c5fa0cec.png";